import React, {Component} from 'react'
import axios from 'axios';
import PropTypes from 'prop-types'
import cn from 'classnames'
import {canIncrementAnswers, QUESTION_STATUSES} from '../../../../modules/questions'
import {CONFIRM, SELECT, SELECT3, INFO, INFO_TYPE_ERROR, INFO_TYPE_INFO, QBM_SEND, QBM_USER_BOOKS, QBM_QUIZ, showModal, MODAL_FORM_QBM, QBM_PRESENTATION, QBM_SHARED_QUESTION} from '../../../../modules/modals'
import TextEditor from '../TextEditor'
import toggleOpen from '../../../../decorators/toggleOpen'
import Toggle from "react-toggle"
import Answers from './Answers'
import {getSortStringCB, sortCB} from '../../../../helpers/common'
// import Description from './Description' // TODO think of separating description and answers part
import {ajaxUrls} from "../../../../settings/routes"
import {reuploadQuestions} from "../../../../modules/questions"
import RestService from '../../../../helpers/RestService'
import Difficulty from './components/Difficulty';
import {toastr} from 'react-redux-toastr'
import Labels from './components/Labels/Labels';
import Comments from './components/Comments/Comments';

class QuestionForm extends Component {
    state = {
        lastAnswerFocused : false,
        showAnswersPopover : false,
    }
    render() {
        const {BackendErrors, Header, Body, Buttons} = this
        BackendErrors.displayName = 'BackendErrors'
        Header.displayName = 'Header'
        Body.displayName = 'Body'
        Buttons.displayName = 'Buttons'
        const {viewMode, style} = this.props
        return (

            <div className="question-body_buttons pb-4 pt-4" style = {style} >
                <div className="question-component">
                    {
                        !viewMode && <BackendErrors />
                    }
                    <Header />
                    <Body />
                </div>
                {
                    !viewMode && <Buttons />
                }
            </div>
        )
    }

    copyQuestion = (question) => {
        const {formatMessage} = this.context;
        var textArea = document.createElement("textarea");

        const answer = [];
        const arr = ['A: ', 'B: ', 'C: ', 'D: ', 'E: ', 'F: ', 'G: ', 'H: ', 'I: ', 'J: ']

        let current = '';
        for (let index = 1; index < 11; index++) {
            if(question.answerT1['answer_' + index]){
                answer.push(question.answerT1['answer_' + index])
                if('answer_' + index == question.answerT1.correct_answer){
                    current = arr[index]
                }
            } 
            
        }

        

         

        textArea.value = 'Question: ' + question.body.replace(/<\/?[^>]+(>|$)/g, "") + '\n' 
        + 'Answers: ' + '\n' 
        + (answer.map((v, i) => arr[i] + v).join('\n')) + '\n'
        + 'Current answer: ' 
        + current.replace(': ', '')  + '\n' 
        + 'Description: '
        + question.description.replace(/<\/?[^>]+(>|$)/g, "");
        
        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        // textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            toastr.success(formatMessage('copyQuestionTitle'), formatMessage('copyQuestionMsg'))
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    Header = () => {
        const {viewMode, question : {id : questionId, isNewForm, status, additional = false}, subject : {name : subjectName}, category : {name : categoryName}, subcategory, source, isTemp = false, isTrashed = false, isTeacherOrganisation, permission} = this.props
        const {formatMessage} = this.context
        return (
            <div>
                <div className="question-header" style = {{backgroundColor : (QUESTION_STATUSES[status] ? QUESTION_STATUSES[status].color : "")}}>
                    {
                        !isNewForm &&
                        <div>
                            <span>#{questionId}</span>
                        </div>
                    }
                    {
                        !isTemp &&
                        <div>
                            <div className="word-wrap-break">
                                <span className="question_items">{formatMessage("Subject")}:</span> {subjectName}
                            </div>
                            <div className="word-wrap-break">
                                <span onClick={this.handleChangeBelonging('category')} className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Category")}:</span> {categoryName}
                            </div>
                            <div className="word-wrap-break">
                                <span onClick={this.handleChangeBelonging('subcategory')} className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Subcategory")}:</span> {subcategory ? subcategory.name : formatMessage("undefined")}
                            </div>
                            <div className="word-wrap-break">
                                <span onClick={this.handleChangeBelonging('source')} className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Source")}:</span> {source ? source.name : formatMessage("undefined")}
                            </div>
                            <div className="word-wrap-break">
                                <span className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("titleQuestionDifficulty")}:</span> <Difficulty handleChangeDifficulty={this.handleChangeDifficulty} notUpdate={true} formatMessage={formatMessage} question={this.props.question} />
                            </div>
                            <Labels formatMessage={formatMessage} question={this.props.question} />
                        </div>
                    }
                    {
                        isTemp &&
                        <div>
                            <div className="word-wrap-break">
                                <span className="question_items">{formatMessage("Subject")}:</span> {additional.branch}
                            </div>
                            <div className="word-wrap-break">
                                <span className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Category")}:</span> {additional.category}
                            </div>
                            <div className="word-wrap-break">
                                <span className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Subcategory")}:</span> {additional.subcategory ? additional.subcategory : formatMessage("undefined")}
                            </div>
                            <div className="word-wrap-break">
                                <span className={cn("question_items", {"pointer" : !viewMode})}>{formatMessage("Source")}:</span> {additional.source ? additional.source : formatMessage("undefined")}
                            </div>
                        </div>
                    }
                    {
                        !isNewForm && !isTemp && !isTrashed &&
                        <nav className="nav">

                            <input className="nav__check" type="checkbox" id={'checkbox_'+questionId }/>
                            <label className="nav__showmenu" htmlFor={'checkbox_'+questionId }>&#9776;</label>
                            <label className="nav__back" htmlFor={'checkbox_'+questionId }></label>
                            <ul className="check_menu">
                                <li><span className="menu__item" onClick={this.handleCopy(this.props.question)} >{formatMessage("mnuDuplicateQuestion")}</span></li>
                                <li><span className="menu__item" onClick={this.handleSend(this.props.question)} >{formatMessage("mnuSendQuestion")}</span></li>
                                <li><span className="menu__item" onClick={this.createQuiz(this.props.question.id)} >{formatMessage("mnuToQuiz")}</span></li>
                                <li><span className="menu__item" onClick={this.createPresentation(this.props.question.id)} >{formatMessage("mnuToPresentation")}</span></li>
                                <li><span className="menu__item" onClick={this.charedQuestion(this.props.question.id)} >{formatMessage("mnuSharedQuestion")}</span></li>
                                <li><span className="menu__item" onClick={() => this.copyQuestion(this.props.question)} >{formatMessage("mnuCopyQuestion")}</span></li>
                            </ul>
                        </nav>
                    }
                </div>
                {
                    isTemp &&
                    <div>
                        <input className="nav__check" type="checkbox" id={'checkbox_'+questionId }/>
                        <span className="menu__item" id={"shareQuestionBtn"} style={
                            {
                                margin: '10px auto 10px auto',
                                color: '#00adff',
                                display: 'block',
                                fontSize: '18px'
                            }
                        } onClick={this.handleSaveTemp(this.props.question)} >{formatMessage("mnuChooseDestination")}</span>
                    </div>
                }
            </div>

        )
    }


    initRest = () => {
        axios.defaults.headers.common = {
            'Accept': 'application/json, text/plain',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
            'X-Requested-With' : 'XMLHttpRequest',
        };
    }
    componentDidMount() {
        axios.defaults.headers.common = {
            'Accept': 'application/json, text/plain',
            'X-CSRF-Token': RestService.getCsrfToken(),
            'X-Requested-With' : 'XMLHttpRequest',
        };
    }
    handleSend = () => () =>{
        const{showModal, hideModal, question : {id : questionId}} = this.props
        showModal({
            modalType : QBM_SEND,
            modalProps : {
                qbmEntity : "source",
                qbmId: questionId,
                qbmCrudAction : 'create',
                okCb : (value) => {
                    console.log(value)
                }
            }
        });
        
    }

    createQuiz = () => () => {
        const{showModal, hideModal, question : {id : questionId}, isTeacherOrganisation, permission} = this.props;
        const {formatMessage} = this.context
        if(isTeacherOrganisation && permission && !permission.quizzes){
            toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
            return ;
        }

        showModal({
            modalType : QBM_QUIZ,
            modalProps : {
                selectedQuestionIds: [questionId]
            }
        });
    }

    createPresentation = () => () => {
        const{showModal, hideModal, question : {id : questionId}, isTeacherOrganisation, permission } = this.props;
        const {formatMessage} = this.context
        if(isTeacherOrganisation && permission && !permission.lecture_hall){
            toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
            return ;
        }

        showModal({
            modalType : QBM_PRESENTATION,
            modalProps : {
                selectedQuestionIds: [questionId]
            }
        });
    }

    charedQuestion = () => () => {
        const{showModal, hideModal, question , isTeacherOrganisation, permission } = this.props;
        console.log("🚀 ~ file: QuestionForm.jsx ~ line 201 ~ QuestionForm ~ question", question)
        const {formatMessage} = this.context
        // if(isTeacherOrganisation && permission && !permission.lecture_hall){
        //     toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
        //     return ;
        // }

        showModal({
            modalType : QBM_SHARED_QUESTION,
            modalProps : {
                id: [question.token]
            }
        });
    }

    handleSaveTemp = () => () => {
        const {viewMode, isTemp, question : {id : questionId}, createCopyForm, showModal, hideModal, sources, source, subject, subjects, copy, handleQuestionSave} = this.props
        document.getElementById("checkbox_"+questionId).checked = false;
        if (!isTemp) return
        //this.initRest()
        const {formatMessage} = this.context
        let _category_id = null
        let _subcategory_id = null
        let _subject_id = null
        let _question_id = questionId
        let to = 'subject'
        let options
        let initValue
        let currentRecord = this.props.question
        let that = this
        axios({
            method: 'post',
            url:ajaxUrls.subjectListActive,
            headers: {
                'Accept': 'application/json, text/plain',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest',
            }
        })
            .then(function (response) {
                options = response.data.subjects.sort(sortCB)
                initValue = subject ? {id : subject.id, name : subject.name} : null
                options = options.sort(sortCB)
                showModal({
                    modalType : SELECT3,
                    modalProps : {
                        title : formatMessage(`txtChooseWhereToSave`),
                        confirmText : formatMessage(`Choose another ${to}`),
                        okButtonTxt : formatMessage("Ok"),
                        cancelButtonTxt : formatMessage("Cancel"),
                        initValue,
                        options,
                        //clearable : (to !== 'subject'),
                        okCb : (value) => {
                            _subject_id = value ? value.id : null
                            if(null === _subject_id || typeof value.value2.id === 'undefined'){
                                hideModal({modalType:SELECT3})
                                showModal({
                                    modalType : INFO,
                                    modalProps : {
                                        title : "Error",
                                        text : 'You need to choose a category',
                                        infoType : INFO_TYPE_ERROR,
                                    }
                                })
                                return false
                            }

                            let xxx = {
                                id: questionId,
                                subject_id : value.value.id,
                                category_id : value.value2.id,
                                source_id : null,
                                subcategory_id: null,
                                real_category: null
                            }

                            if(typeof value.value2.id !== 'undefined' && null !== value.value2.id){
                                xxx.category_id = (value.value2.id)
                                xxx.real_category = (value.value2.id)
                            }
                            if(typeof value.value3.id !== 'undefined' && null !== value.value3.id){
                                xxx.category_id = (value.value3.id)
                                xxx.subcategory_id = (value.value3.id)
                            }
                            window.state.tempForSave = xxx;
                            hideModal({modalType:SELECT3})
                            //console.log(window.state.tempForSave);
                        }
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            }); return false;
    }
    handleCopy = () => () => {
        const {viewMode, isTemp, question : {id : questionId}, createCopyForm, showModal, hideModal, sources, source, subject, subjects, copy, handleQuestionSave} = this.props
        document.getElementById("checkbox_"+questionId).checked = false;
        if (viewMode) return
        //this.initRest()
        const {formatMessage} = this.context
        let _category_id = null
        let _subcategory_id = null
        let _subject_id = null
        let _question_id = questionId
        let to = 'subject'
        let options
        let initValue
        let currentRecord = this.props.question
        axios({
            method: 'post',
            url:ajaxUrls.subjectListActive,
            headers: {
                'Accept': 'application/json, text/plain',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest',
            }
        })
            .then(function (response) {
                options = response.data.subjects.sort(sortCB)
                initValue = subject ? {id : subject.id, name : subject.name} : null
                options = options.sort(sortCB)
                showModal({
                    modalType : SELECT3,
                    modalProps : {
                        title : formatMessage(`frmSelectDestinationCopyQuestionCaption`),
                        confirmText : formatMessage(`Choose another ${to}`),
                        okButtonTxt : formatMessage("btnCopyQuestion"),
                        cancelButtonTxt : formatMessage("Cancel"),
                        initValue,
                        options,
                        //clearable : (to !== 'subject'),
                        okCb : (value) => {
                            _subject_id = value ? value.id : null
                            if(null === _subject_id || typeof value.value2.id === 'undefined'){
                                hideModal({modalType:SELECT3})
                                showModal({
                                    modalType : INFO,
                                    modalProps : {
                                        title : "Error",
                                        text : 'You need to choose a category',
                                        infoType : INFO_TYPE_ERROR,
                                    }
                                })
                                return false
                            }

                            let xxx = {
                                subject_id : value.value.id,
                                category_id : value.value2.id,
                                source_id : null,
                                subcategory_id: null,
                                real_category: null
                            }

                            if(typeof value.value2.id !== 'undefined' && null !== value.value2.id){
                                xxx.category_id = ('cat_'+value.value2.id)
                                xxx.real_category = ('cat_'+value.value2.id)
                            }
                            if(typeof value.value3.id !== 'undefined' && null !== value.value3.id){
                                xxx.category_id = ('subcat_'+value.value3.id)
                                xxx.subcategory_id = ('subcat_'+value.value3.id)
                            }
                            const tempId = (Date.now() + Math.random()).toString()
                            xxx.tempId = tempId
                            createCopyForm(currentRecord, xxx)
                            setTimeout(function () {
                              handleQuestionSave({questionId:tempId, needCheck:false})
                            }, 1500)
                            hideModal({modalType:SELECT3})
                        }
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            }); return false;
    }
    handleChangeBelonging = (to) => () => {
        if (!['category', 'subcategory', 'source'].includes(to)) return
        const {viewMode, question : {id : questionId, category_id : questionCategoryId}, changeQuestionSource, changeQuestionCategory, showModal, hideModal, sources, source, categoriesTree, category : {id : categoryId, name : categoryName}, handleQuestionSave} = this.props

        if (viewMode) return

        const {formatMessage} = this.context

        let options
        let initValue
        if (to === 'source') {
            options = sources.sort(getSortStringCB('name'))
            initValue = source ? {id : source.id, name : source.name} : null
        } else if (to === 'category') {
            options = categoriesTree.reduce((acc, curr) => ([...acc, {id : curr.id, name : curr.name, created_at : curr.created_at}]), [])
            initValue = {id : categoryId, name : categoryName}
        } else if (to === 'subcategory') {
            let _category = categoriesTree.find(cat => cat.id === questionCategoryId)
            if (!_category) {
                let __category = categoriesTree.find(cat => cat.subcategories.find(subcat => subcat.id === questionCategoryId))
                if (!__category) {
                    options = []
                    initValue = null
                } else {
                    let {subcategories} = __category
                    options = subcategories
                    let __subcategory = subcategories.find(cat => cat.id === questionCategoryId)
                    initValue = __subcategory ? {id : __subcategory.id, name : __subcategory.name} : null
                }
            } else {
                options = _category.subcategories
                let _subcategory = _category.subcategories.find(cat => cat.id === questionCategoryId)
                initValue = _subcategory ? {id : _subcategory.id, name : _subcategory.name} : null
            }
        }

        if (to === 'source') {
            options = options.sort(getSortStringCB('name'))
        } else if (to === 'category' || to === 'subcategory') {
            options = options.sort(sortCB)
        }

        showModal({
            modalType : SELECT,
            modalProps : {
                title : formatMessage(`Choosing ${to}`),
                confirmText : formatMessage(`Choose another ${to}`),
                okButtonTxt : formatMessage("Choose"),
                cancelButtonTxt : formatMessage("Cancel"),
                initValue,
                options,
                clearable : (to !== 'category'),
                okCb : (value) => {
                    const id = value ? value.id : null
                    if (['category', 'subcategory'].includes(to)) changeQuestionCategory({questionId, category_id : id, prev_category_id : questionCategoryId})
                    if (to === 'source') changeQuestionSource({questionId, source_id : id})
                    handleQuestionSave({questionId, needCheck : false})
                    hideModal({modalType:SELECT})
                }
            }
        })
    }


    handleEditButtonClick = () => {

        const {initData, showModal, isTeacherOrganisation, permission} = this.props;
        const {formatMessage} = this.context

        if(isTeacherOrganisation && permission && !permission.add_new_question){
            toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
            return ;
        }

        showModal({
            modalType: MODAL_FORM_QBM,
            modalProps: {
                initialValues: initData
            }
        })
    }

    Buttons = () => {
        const {StatusButton} = this
        StatusButton.displayName = 'StatusButton'
        const {question : {isNewForm}} = this.props
        const toMap = Object.assign({}, QUESTION_STATUSES);
        delete toMap[4];
        return (
            <div className="question-buttons">
                <StatusButton
                    key = {'edit'}
                    imgSrc = {'/build/images/method-draw-image.svg'}
                    label = {this.context.formatMessage('Edit')}
                    onClick = {this.handleEditButtonClick}
                />
                {
                    Object.values(toMap)
                        .sort(({order : aOrder}, {order : bOrder}) => aOrder - bOrder)
                        .map(({status, imgSrc, label}) => (
                            !isNewForm ?
                                <StatusButton
                                    key = {status}
                                    imgSrc = {imgSrc}
                                    label = {this.context.formatMessage(label)}
                                    onClick = {this.handleStatusButtonClick(status)}
                                /> :
                                status === 0 ?
                                    <StatusButton
                                        key = {status}
                                        imgSrc = {imgSrc}
                                        label = {this.context.formatMessage(label)}
                                        onClick = {this.handleStatusButtonClick(status)}
                                    /> :
                                    null
                        ))
                }
            </div>
        )
    }
    StatusButton = ({imgSrc, label, onClick, isBorder}) => (
        <div onClick = {onClick}>
            <img src={imgSrc} style={{border: isBorder ? 'solid 1px #ccc': 'none'}} width="68" height="68" title={this.context.formatMessage(label)} />
        </div>
    )
    handleStatusButtonClick = (status) => async() => {
        const {question : {id : questionId, isNewForm}, setLoadCursore, changeQuestionsStatuses, handleQuestionSave, handleQuestionDelete, showModal, hideModal, deleteQuestion} = this.props
        const {formatMessage} = this.context
        const {isTeacherOrganisation, permission} = this.props;
        if (status === 0) {
            if (isNewForm) {
                deleteQuestion({questionId})
            } else {

                if(isTeacherOrganisation && permission && !permission.allow_delete_question){
                    toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
                    return ;
                }

                showModal({
                    modalType : CONFIRM,
                    modalProps : {
                        title : formatMessage("Deleting question"),
                        confirmText : formatMessage(`Do you really want to delete the question with id`) + ` ${questionId}?`,
                        okButtonTxt : formatMessage("Yes"),
                        cancelButtonTxt : formatMessage("No"),
                        okCb : () => {
                            handleQuestionDelete({questionId})
                            hideModal({modalType:CONFIRM})
                        }
                    }
                })
            }
        } else {
            await changeQuestionsStatuses({changeData : [{questionId, status, syncLs : false}]})
            await handleQuestionSave({questionId});
        }
    }
    Body = () => {
        const {AnswersToggle, Description, AnswersPopover, CommentsBlock} = this
        AnswersToggle.displayName = 'AnswersToggle'
        Description.displayName = 'Description'
        AnswersPopover.displayName = 'AnswersPopover'
        CommentsBlock.displayName = 'CommentsBlock'
        const {viewMode, question : {id : questionId, body, answ_state, expl_state, comment_state, form : {state : {isTouched}, errors : {body : bodyErrors}}}} = this.props

        return (
            <div className="question-body" onClick={this.handleBodyTouch}>
                <div
                    className="text-editor-popup-wrapper"
                    onMouseEnter={this.handleQuestionBodyMouseEnter}
                    onMouseLeave={this.handleQuestionBodyMouseLeave}
                >
                    {
                        (!viewMode && (this.state.showAnswersPopover && !answ_state)) &&
                        <AnswersPopover />
                    }
                    <div className="text-editor-block" style={{padding: 10, margin: '10px 0', border: 'solid 1px #ccc', wordWrap: 'anywhere'}} dangerouslySetInnerHTML={{__html: body}}  />
                    {/* <TextEditor
                        questionId = {questionId}
                        value = {body}
                        onChange = {this.handleChangeTextEditor('body')}
                        editorType = "questionBody"
                        viewMode = {viewMode}
                        handleMeasurer = {this.handleMeasurer}
                    /> */}
                </div>
                {
                    !viewMode && isTouched && bodyErrors.length ?
                        bodyErrors.map(error => (
                            <p key = {error} className="text-danger">{error}</p>
                        )) :
                        null
                }
                <AnswersToggle initOpen = {viewMode ? true : !!answ_state} forceOpen = {viewMode ? true : !!answ_state} />
                <Description initOpen = {viewMode ? true : !!expl_state} forceOpen = {viewMode ? true : !!expl_state} />
                <CommentsBlock initOpen = {viewMode ? true : !!comment_state} forceOpen = {viewMode ? true : !!comment_state} />
            </div>
        )
    }
    BackendErrors = () => {
        const {question : {form : {state : {isTouched}, errors : {backend : backendErrors}}}} = this.props
        return isTouched && backendErrors.length ?
            backendErrors.map(error => (
                <p key = {error} style={{margin:0, paddingTop:5, paddingBottom:5, color: "red"}} className="text-center text-danger">{this.context.formatMessage(error)}</p>
            )) :
            null
    }
    
    CommentsBlock = toggleOpen(({isOpen, toggleOpen}) => {
        const {viewMode, question : {id : questionId, comments}} = this.props
        const {Toggler} = this
        const {formatMessage} = this.context;
        Toggler.displayName = "Toggler"
        return [
            !viewMode &&
            <Toggler
                key="1"
                isOpen = {isOpen}
                toggleOpen = {this.handleToggleOpen('comment')(isOpen)(toggleOpen)}
                toggleLabel = {this.context.formatMessage("Hide comment")}
            />,
            isOpen && (
                <Comments comments={comments} questionId={questionId} formatMessage={formatMessage} />
            )
        ]
    })

    Description = toggleOpen(({isOpen, toggleOpen}) => {
        const {viewMode, question : {id : questionId, description}} = this.props
        const {Toggler} = this
        const {formatMessage} = this.context;
        Toggler.displayName = "Toggler"
        return [
            !viewMode &&
            <Toggler
                key="1"
                isOpen = {isOpen}
                toggleOpen = {this.handleToggleOpen('description')(isOpen)(toggleOpen)}
                toggleLabel = {this.context.formatMessage("Hide explanation")}
            />,
            isOpen && (
                <div className="text-editor-block" style={{padding: 10, margin: '10px 0', border: 'solid 1px #ccc'}} dangerouslySetInnerHTML={{__html: description || `<p style="text-align: center"></p>`}}  />
                // <TextEditor
                //     key="2"
                //     questionId = {questionId}
                //     value = {description}
                //     onChange = {this.handleChangeTextEditor('description')}
                //     editorType = "questionDescription"
                //     viewMode = {true}
                //     handleMeasurer = {this.handleMeasurer}
                // />
            )
        ]
    })
    AnswersToggle = toggleOpen(({isOpen, toggleOpen}) => {
        const {viewMode, question : {form : {state : {isTouched}, errors : {answers : answersErrors}}}, answers} = this.props
        const {Toggler} = this
        Toggler.displayName = "Toggler"
        return [
            !viewMode &&
            <Toggler
                key="1"
                isOpen = {isOpen}
                toggleOpen = {this.handleToggleOpen('answers')(isOpen)(toggleOpen)}
                toggleLabel = {this.context.formatMessage("Hide answers")}
            />,
            isOpen && (
                <Answers
                
                    key="2"
                    answers = {answers}
                    handleAnswerBlur = {this.handleAnswerBlur}
                    handleAnswerChange = {this.handleAnswerChange}
                    handleAnswerCancelClick = {this.handleAnswerCancelClick}
                    handleAnswerOkClick = {this.handleAnswerOkClick}
                    lastAnswerFocused = {this.state.lastAnswerFocused}
                    viewMode = {true}
                />
            ),
            isTouched && answersErrors.length ?
                answersErrors.map(error => (
                    <p key = {error} className="text-danger">{this.context.formatMessage(error)}</p>
                )) :
                null,
            (!true && isOpen) &&
            <button onClick={this.handleAddAnswer} key = "3" className={cn("question-type pull-left", {block : !canIncrementAnswers(answers)})}>
                <span className="question-type-plus-icon">+</span> {this.context.formatMessage("Add answer")}
            </button>
        ]
    })
    AnswersPopover = () => {
        const {answers} = this.props
        return (
            <div className="answer-popover">
                <Answers
                    answers = {answers}
                    viewMode = {true}
                    isPopover
                />
                <div className="answer-popover-arrow"></div>
            </div>
        )
    }
    Toggler = ({isOpen, toggleOpen, toggleLabel}) => (
        <div className="toggle-block toggle-block--indent-bottom">
            <div className="toggle-component">
                <span className={cn("toggle-label", {"active" : isOpen})}>{toggleLabel}</span>
                <Toggle checked = {isOpen} onChange = {toggleOpen} icons = {false} />
            </div>
        </div>
    )

    handleQuestionBodyMouseEnter = () => {
        if (!this.state.showAnswersPopover) this.setState(() => ({showAnswersPopover:true}))
    }
    handleQuestionBodyMouseLeave = () => {
        if (this.state.showAnswersPopover) this.setState(() => ({showAnswersPopover:false}))
    }
    handleAnswerOkClick = (storeKey) => () => {
        const {question : {id : questionId, answerT1}, handleAnswerOk, handleQuestionSave, showModal, hideModal, formValidation} = this.props
        const {formatMessage} = this.context
        if (!answerT1[storeKey]) return
        if (answerT1.correct_answer === storeKey) return

        if (!answerT1.correct_answer) {
            handleAnswerOk({storeKey, questionId})
            formValidation({questionId})
            handleQuestionSave({questionId, needCheck : false})
            return
        }

        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : formatMessage("Changing correct answer"),
                confirmText : formatMessage("Do you really want to change the correct answer?"),
                okButtonTxt : formatMessage("Yes"),
                cancelButtonTxt : formatMessage("No"),
                okCb : () => {
                    handleAnswerOk({storeKey, questionId})
                    formValidation({questionId})
                    handleQuestionSave({questionId, needCheck : false})
                    hideModal({modalType:CONFIRM})
                }
            }
        })


    }
    handleAnswerCancelClick = (storeKey) => () => {
        const {questionId, handleAnswerCancel, handleQuestionSave, showModal, hideModal} = this.props
        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : "Deleting answer",
                confirmText : "Do you really want to delete the answer?",
                okButtonTxt : "Yes",
                cancelButtonTxt : "No",
                okCb : () => {
                    handleAnswerCancel({storeKey, questionId})
                    handleQuestionSave({questionId})
                    hideModal({modalType : CONFIRM})
                }
            }
        })
    }
    handleAnswerChange = (storeKey) => (event) => {
        const {question : {id : questionId}, changeAnswer, formValidation} = this.props
        changeAnswer({questionId, storeKey, value : event.target.value})
        formValidation({questionId})


    }
    handleAddAnswer = () => {
        const {questionId, incrAnswersCount, answers} = this.props
        if (canIncrementAnswers(answers)) {
            incrAnswersCount(questionId)
            this.setState({lastAnswerFocused : true}, this.handleMeasurer)
        }
    }
    handleChangeTextEditor = (type) => (editorState) => {
        const {question : {id : questionId}, changeQuestionBody, changeQuestionDescription} = this.props
        if (type === 'body') changeQuestionBody({questionId, editorState})
        if (type === 'description') changeQuestionDescription({questionId, editorState})

        this.handleMeasurer()
    }
    handleChangeDifficulty = (editorState) => {
        const {question : {id : questionId, isNewForm}, changeDifficulty, handleQuestionSave} = this.props
        changeDifficulty({questionId, editorState})
        if(!isNewForm){
            handleQuestionSave({questionId, needCheck : false});
        }
        
        this.handleMeasurer()
    }
    handleAnswerBlur = () => {
        const {viewMode, question : {id : questionId}, handleQuestionSave} = this.props
        if (!viewMode) handleQuestionSave({questionId})
        if (this.state.lastAnswerFocused) this.setState({lastAnswerFocused : false})
    }
    handleBodyTouch = () => {
        const {question : {id : questionId}, setQuestionFormState} = this.props
        setQuestionFormState({questionId, stateData : [{key : "isTouched", value : true}]})

        this.handleMeasurer()
    }

    handleToggleOpen = (toggleKey) => (isOpen) => (toggleOpen) => () => {
        if (!["description", "answers", 'comment'].includes(toggleKey)) return
        const {viewMode, question : {id : questionId}, handleQuestionSave, toggleQuestionState} = this.props
        if (viewMode) return

        // if (!isOpen) {
        //     this.handleMeasurer()
        //     toggleOpen()
        //     this.handleMeasurer()
        // } else {
        //     this.handleMeasurer()
        //     toggleOpen()
        //     this.handleMeasurer()
        // }

        toggleOpen()



        toggleQuestionState({questionId, toggleKey})
        handleQuestionSave({questionId, needCheck : false})
    }

    handleMeasurer = () => {
        this.props.measure && this.props.measure()
    }

    handleMassMeasurer = () => {
        this.props.massMeasurer && this.props.massMeasurer()
    }

    componentWillReceiveProps(nextProps) {
        const {question : {answ_state : nextAnswState, expl_state : nextExplState, comment_state: nextCommentState}} = nextProps
        const {viewMode, question : {answ_state : currAnswState, expl_state : currExplState, comment_state: currCommentState}} = this.props
        if (!viewMode && (nextAnswState !== currAnswState || nextExplState !== currExplState || nextCommentState !== currCommentState)) setTimeout(this.handleMeasurer, 300) // this.handleMeasurer()// this.handleMassMeasurer()
    }

    componentWillUnmount() {
        const {handleResetQuestionFormState, deleteQuestion, question : {id : questionId, isNewForm}} = this.props
        handleResetQuestionFormState({questionId})
        if (isNewForm) {
            deleteQuestion({questionId})
        }
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default QuestionForm


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/QuestionForm.jsx